import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { IoArrowBackOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import {
  addOnlyQuiz,
  updateOnlyQuiz,
  fetchOnlyQuizById,
  clearSelectedOnlyQuiz,
} from "../../../store/reducers/onlyQuizSectionSlice";

import { fetchActiveQuestions } from "../../../store/reducers/questionsSectionSlice";
import DraggableSelectList from "../questionsSection/components/QuestionListDropdown";

const OnlyQuizAddUpdate = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const params = new URLSearchParams(location.search);
  const quizId = params.get("id");

  const { selectedOnlyQuiz, singleLoading } = useSelector(
    (state) => state.onlyQuiz
  );

  const { activeQuestions } = useSelector((state) => state.questions);

  const [options, setOptions] = useState([]);
  const [selectedQuestionIds, setSelectedQuestionIds] = useState([]);
  const [defaultQuestionIds, setDefaultQuestionIds] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    name_dk: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(fetchActiveQuestions());
  }, [dispatch]);

  useEffect(() => {
    if (activeQuestions) {
      const formatted = activeQuestions.map((q) => ({
        label: q.question,
        value: q.id,
      }));
      setOptions(formatted);
    }
  }, [activeQuestions]);

  const handleSelectedIds = (ids) => {
    setSelectedQuestionIds(ids);
  };

  useEffect(() => {
    if (quizId) {
      dispatch(fetchOnlyQuizById(quizId));
    }
    return () => dispatch(clearSelectedOnlyQuiz());
  }, [quizId]);

  useEffect(() => {
    if (selectedOnlyQuiz && quizId) {
      setFormData({
        name: selectedOnlyQuiz.name || "",
        name_dk: selectedOnlyQuiz.name_dk || "",
      });

      setSelectedQuestionIds(selectedOnlyQuiz.question_ids || []);
      setDefaultQuestionIds(selectedOnlyQuiz.question_ids || []);
    }
  }, [selectedOnlyQuiz]);

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const validateForm = () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "English name is required";
    }

    if (!formData.name_dk.trim()) {
      newErrors.name_dk = "Danish name is required";
    }

    if (selectedQuestionIds.length === 0) {
      newErrors.question_ids = "Select at least one question";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      const payload = {
        ...formData,
        question_ids: selectedQuestionIds,
      };

      if (quizId) {
        await dispatch(updateOnlyQuiz({ id: quizId, data: payload })).unwrap();
        toast.success("Quiz Updated Successfully");
      } else {
        await dispatch(addOnlyQuiz(payload)).unwrap();
        toast.success("Quiz Added Successfully");
      }

      history.push("/admin-quiz-section");
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="mt-3">
      <div className="d-flex align-items-center mb-4">
        <button
          className="btn btn-outline-secondary btn-sm me-3"
          onClick={() => history.push("/admin-quiz-section")}
        >
          <IoArrowBackOutline /> Back
        </button>

        <h5 className="mb-0 fw-bold">{quizId ? "Update Quiz" : "Add Quiz"}</h5>
      </div>

      {singleLoading ? (
        <div className="text-center p-5">Loading quiz...</div>
      ) : (
        <form onSubmit={handleSubmit} className="p-2">
          <div className="mb-3">
            <label className="form-label">Name (English)*</label>
            <input
              type="text"
              name="name"
              className={`form-control ${errors.name ? "is-invalid" : ""}`}
              value={formData.name}
              onChange={handleChange}
            />
            <div className="invalid-feedback">{errors.name}</div>
          </div>

          <hr style={{ color: "red" }} />
          <div className="mb-3">
            <label className="form-label">Name (Danish)*</label>
            <input
              type="text"
              name="name_dk"
              className={`form-control ${errors.name_dk ? "is-invalid" : ""}`}
              value={formData.name_dk}
              onChange={handleChange}
            />
            <div className="invalid-feedback">{errors.name_dk}</div>
          </div>

          <hr style={{ color: "red" }} />

          <label>Select Questions*</label>
          <DraggableSelectList
            options={options}
            defaultValues={defaultQuestionIds}
            onChange={handleSelectedIds}
          />
          {errors.question_ids && (
            <div className="text-danger mt-1">{errors.question_ids}</div>
          )}

          <hr style={{ color: "red" }} />

          {/* BUTTON */}
          <div className="mt-4">
            <button type="submit" className="btn bg_color px-4">
              {quizId ? "Update Quiz" : "Add Quiz"}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default OnlyQuizAddUpdate;
